import axiosClient from './axiosClient'
const wardApi = {
  getAll: (params) => {
    const url = '/ward/getAll'
    return axiosClient.get(url, { params })
  },
}
export default wardApi
